module.exports = __webpack_public_path__ + "static/media/h1.313a0751.svg";